(async () => {

  if (!customElements.get('product-dynamic-recommendations')) {

    let { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);
    class ProductDynamicRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-dynamic-recommended-products]');
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 1,
          direction: 'horizontal',
          watchSlidesProgress: true,
          breakpoints: {
            360: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          let jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        window.onload = () => {
          this.init();
        }
      }

      init() {

        let fetch_url = '';
        if (this.dataset) {
          // related products
          if (this.dataset.relatedProducts) {
            fetch_url = location.origin + this.dataset.relatedProducts;
          } else {
            // recommended products
            if (this.dataset.url) {
              fetch_url = location.origin + this.dataset.url;
            }
          }

          if (fetch_url !== '') {
            fetch(fetch_url)
            .then(response => response.text())
            .then(text => {

              let html = document.createElement('div');
              html.innerHTML = text;

              // remove self product or last item
              if (this.dataset.productHandle) {
                let product_url = '[href="/products/' + this.dataset.productHandle + ']"';
                let product = html.querySelector(product_url);
                if (product !== null) {
                  product.closest('.swiper-slide').remove();
                } else {
                  let nodes = html.querySelectorAll('.swiper-slide');
                  nodes[nodes.length- 1].remove();
                }
              }

              let source = html.querySelector('[data-recommended-products]');
              let target = this.querySelector('[data-recommended-products]');

              if (source && source.innerHTML && source.innerHTML.trim().length) {
                target.innerHTML = source.innerHTML;
              }

              this.swiperInstance.update();

            })
            .catch(e => {
              console.error(e);
            });
          }
        }

      }
    }

    window.ProductDynamicRecommendations = ProductDynamicRecommendations;

    customElements.define('product-dynamic-recommendations', ProductDynamicRecommendations);

  }

})();
